import React, { useState } from 'react'
import { Target, Zap, BarChart3, Brain } from 'lucide-react'
import LoginForm from './LoginForm'
import SignUpForm from './SignUpForm'

const AuthPage: React.FC = () => {
  const [isSignUp, setIsSignUp] = useState(false)

  const toggleMode = () => {
    setIsSignUp(!isSignUp)
  }

  return (
    <div className="min-h-screen bg-gray-900 flex">
      {/* Left side - Branding */}
      <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-indigo-600 via-purple-600 to-blue-700 relative overflow-hidden">
        <div className="absolute inset-0 bg-black bg-opacity-20"></div>
        <div className="relative z-10 flex flex-col justify-center px-12 text-white">
          <div className="mb-8">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 bg-white bg-opacity-20 rounded-xl flex items-center justify-center">
                <Target className="w-8 h-8" />
              </div>
              <h1 className="text-4xl font-bold">ADAPT</h1>
            </div>
            <p className="text-xl text-indigo-100 mb-8">
              Adaptive Framework for Strategic Product Management
            </p>
          </div>

          <div className="space-y-6">
            <div className="flex items-start space-x-4">
              <div className="w-8 h-8 bg-white bg-opacity-20 rounded-lg flex items-center justify-center flex-shrink-0">
                <BarChart3 className="w-5 h-5" />
              </div>
              <div>
                <h3 className="font-semibold mb-2">Strategic Dashboard</h3>
                <p className="text-indigo-100 text-sm">
                  Real-time monitoring of strategic goals and market signals with AI-powered insights.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-8 h-8 bg-white bg-opacity-20 rounded-lg flex items-center justify-center flex-shrink-0">
                <Zap className="w-5 h-5" />
              </div>
              <div>
                <h3 className="font-semibold mb-2">Experiment Hub</h3>
                <p className="text-indigo-100 text-sm">
                  Hypothesis generation, validation, and signal tracking for data-driven decisions.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-8 h-8 bg-white bg-opacity-20 rounded-lg flex items-center justify-center flex-shrink-0">
                <Brain className="w-5 h-5" />
              </div>
              <div>
                <h3 className="font-semibold mb-2">AI Co-Pilot</h3>
                <p className="text-indigo-100 text-sm">
                  Intelligent assistance for prioritization, risk assessment, and opportunity identification.
                </p>
              </div>
            </div>
          </div>

          <div className="mt-12 p-6 bg-white bg-opacity-10 rounded-xl backdrop-blur-sm">
            <blockquote className="text-indigo-100 italic">
              "ADAPT has transformed how we approach product strategy. The AI-powered insights and real-time market signals have increased our decision velocity by 40%."
            </blockquote>
            <div className="mt-4 flex items-center space-x-3">
              <div className="w-10 h-10 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
                <span className="text-sm font-semibold">SC</span>
              </div>
              <div>
                <div className="font-medium">Sarah Chen</div>
                <div className="text-sm text-indigo-200">Chief Product Officer</div>
              </div>
            </div>
          </div>
        </div>

        {/* Decorative elements */}
        <div className="absolute top-20 right-20 w-32 h-32 bg-white bg-opacity-10 rounded-full blur-xl"></div>
        <div className="absolute bottom-20 left-20 w-24 h-24 bg-white bg-opacity-10 rounded-full blur-xl"></div>
      </div>

      {/* Right side - Auth forms */}
      <div className="flex-1 flex items-center justify-center px-6 py-12 lg:px-8">
        <div className="w-full max-w-md">
          {/* Mobile branding */}
          <div className="lg:hidden text-center mb-8">
            <div className="flex items-center justify-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-indigo-600 rounded-xl flex items-center justify-center">
                <Target className="w-6 h-6 text-white" />
              </div>
              <h1 className="text-2xl font-bold text-white">ADAPT</h1>
            </div>
            <p className="text-gray-400">Adaptive Framework</p>
          </div>

          {isSignUp ? (
            <SignUpForm onToggleMode={toggleMode} />
          ) : (
            <LoginForm onToggleMode={toggleMode} />
          )}
        </div>
      </div>
    </div>
  )
}

export default AuthPage